let timer: number | undefined

export function toast(message: string, timeout: number = 2000) {
  const toast = document.querySelector('.js-toast')
  toast?.remove()
  clearTimeout(timer)

  const node = document.createElement('div')
  node.classList.add('c-tooltip', 'u-center', 'js-toast')
  node.innerHTML = message

  document.body.appendChild(node)
  // -1 で開いたままになる
  if (timeout === -1) return
  timer = window.setTimeout(() => {
    node.remove()
  }, timeout)
}
